import * as React from "react";
import "./style.css";
import { useInView } from "framer-motion";
import { useRef } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Footer from "../../Components/Footer";
import { Icons } from "../../Data/cardData";
import useMediaQuery from '@mui/material/useMediaQuery';
export default function Produits() {
  const isSmallScreen = useMediaQuery('(max-width:750px)');
  const ref1 = useRef(null);
  const isInView1 = useInView(ref1, { once: true });
  return (
    <div className="home">
      <div
        className="realisationHome"
        ref={ref1}
        style={{
          transform: isInView1 ? "none" : "translateY(-200px)",
          opacity: isInView1 ? 1 : 0,
          transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s",
        }}
      >
        <h1>Nos Produits</h1>

        <ImageList variant="masonry" cols={isSmallScreen ? 3 : 4} gap={isSmallScreen ? 6 : 8}>
          {Icons?.flatMap((category) => (
            <ImageListItem key={category.nom + "-"}>
                <a href={`/nos-produits/${category.nom}`} >
              <div className="imageContainerProduits">
                <img
                  src={require(`../../Images/Produits/${category.nom}.jpg`)}
                  alt={category.nom}
                  loading="lazy"
                  className="produitsImg"
                />
                <div className="overlayProduits">
                  <span className="projectName">{category.nom}</span>
                </div>
              </div>
              </a>
            </ImageListItem>
          ))}
        </ImageList>
      </div>

      <Footer />
    </div>
  );
}
